const { jsonp } = require("vue");

// 返回年月日
function returnTime(time, _str, s) {
	var _str = _str || "-";
	var mydate = new Date(time);
	var year = mydate.getFullYear();
	var month = mydate.getMonth() + 1;
	var day = mydate.getDate();
	var week = mydate.getDay();
	var hour = mydate.getHours();
	var minute = mydate.getMinutes();
	var second = mydate.getSeconds();
	//		  return { year: year, month: month, day: day, week: week};
	var endTime = year + _str + (month > 9 ? month : "0" + month) + _str + (day > 9 ? day : "0" + day);

	//判断是否返小时
	if (s == "hour") {
		endTime = endTime + " " + (hour < 9 ? ("0") + hour : hour) + ":" + (minute < 9 ? ("0") + minute : minute)
	}

	//判断是否返回秒
	if (s == 's') {
		endTime = endTime + " " + (hour < 9 ? ("0") + hour : hour) + ":" + (minute < 9 ? ("0") + minute : minute) + ":" + (second < 9 ? ("0") + second : second);
	}

	return endTime;
}

// 验证手机号码是否正确
function returnPhone(vle) {
	var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //手机号码
	if (myreg.test(vle)) {
		return 1;
	} else {
		return 0;
	}
}


// 定义一个深拷贝函数  接收目标target参数
function deepClone(target) {
	// 定义一个变量
	let result;
	// 如果当前需要深拷贝的是一个对象的话
	if (typeof target === 'object') {
		// 如果是一个数组的话
		if (Array.isArray(target)) {
			result = []; // 将result赋值为一个数组，并且执行遍历
			for (let i in target) {
				// 递归克隆数组中的每一项
				result.push(deepClone(target[i]))
			}
			// 判断如果当前的值是null的话；直接赋值为null
		} else if (target === null) {
			result = null;
			// 判断如果当前的值是一个RegExp对象的话，直接赋值    
		} else if (target.constructor === RegExp) {
			result = target;
		} else {
			// 否则是普通对象，直接for in循环，递归赋值对象的所有值
			result = {};
			for (let i in target) {
				result[i] = deepClone(target[i]);
			}
		}
		// 如果不是对象的话，就是基本数据类型，那么直接赋值
	} else {
		result = target;
	}
	// 返回最终结果
	return result;
}


//删除提示
function delTips(fn) {
	return function () {
		let args = arguments; // arguments中存着
		this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			if (typeof fn == "function") {
				fn.apply(this, args)//将this和参数传给原函数

			}
		}).catch(() => {
			this.$message({
				type: 'info',
				message: '已取消删除'
			});
		});
	}

}

//提示
function tipsFn(title, fn) {
	return function () {
		let args = arguments; // arguments中存着
		this.$confirm(title || '是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			if (typeof fn == "function") {
				fn.apply(this, args)//将this和参数传给原函数

			}
		}).catch(() => {
			this.$message({
				type: 'info',
				message: '已取消'
			});
		});
	}

}



//判断是否是json
function isJSON(str) {
	if (typeof str == 'string') {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			return false;
		}
	}
}


// 身份证验证
function checkIdCard(idcard) {
	const regIdCard = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/;
	if (!regIdCard.test(idcard)) {
		return false;
	} else {
		return true;
	}
}


//文件上传进度条
function uploadSectionFile(form, successfn, percentFn) {
	var request = new XMLHttpRequest();
	request.open("POST", "https://afe.aapppp.cn/admin/video");
	request.onload = function (e) {
		if (e.currentTarget.status == 200) {
			var data = JSON.parse(request.responseText);
			successfn(data);

		}
	}
	//【上传进度调用方法实现】
	request.upload.onprogress = function (evt) {
		if (evt.lengthComputable) {
			var numbers = Math.round(evt.loaded / evt.total * 100);
			percentFn(numbers)
		}
	};
	request.send(form);
}



// 相差时间
function countDay(start, end) {
	var date1 = new Date(start);
	var date2 = new Date(end);
	var date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24);/*不用考虑闰年否*/
	return date;
}


/*
防抖
@fn =>返回的方法
@time => 多久时间执行一次
@setTime => 计算器
**/
function debounceFn(fn, time) {
	let setTime;
	var time = time || 1500;
	return function () {
		let args = arguments; // arguments中存着e
		// 判断是否有执行过
		if (setTime) {
			clearTimeout(setTime);
		}
		setTime = setTimeout(() => {
			fn.apply(this, args)
		}, time)
	}
}
/*
节流函数
@fn =>返回的方法
@time => 多久时间内执行一次*/
function throttle(fn, time) {
	if (!time) {
		time= 1500
	}
	let _lastTime = null;
	//返回新的函数
	return function () {
		let _nowTime = +new Date();
		if (_nowTime - _lastTime > time || !_lastTime) {
			fn.apply(this, arguments) //将this和参数传给原函数
			_lastTime = _nowTime
		}
	}
};


/*
	数组去重函数
	@param tempArr 需要去重的数组，支持比较json对象，支持字符和数字串去重
 
*/
function remRepeat(tempArr) {
	var tempArrStatus = null;
	var newTempArr = [];
	if (tempArr instanceof Array) {
		tempArrStatus = 'array';
	} else if (typeof tempArr == 'string' || typeof tempArr == 'number') {
		tempArr = JSON.stringify(tempArr).replace(/[\"|\']/g, "");
		tempArr = tempArr.split('');
		tempArrStatus = 'string';
	} else { return false; }


	for (let i in tempArr) {
		if (i == 0) { newTempArr[0] = tempArr[0]; }
		for (let j in newTempArr) {
			if (JSON.stringify(tempArr[i]) == JSON.stringify(newTempArr[j])) {
				break;
			}
			if (j == newTempArr.length - 1) {
				newTempArr.push(tempArr[i]);
			}
		}
	}
	if (tempArrStatus == 'string') { return newTempArr.join('') }
	return newTempArr;
}


// 前端获取url参数方法
function getUrlParams() {
	var params = {};
	var query = window.location.href.replace(/.*\?/, "");
	/http/.test(query) && (query = "");
	var tempVar = query ? query.split("&") : [];
	for (var k in tempVar) {
		params[tempVar[k].split("=")[0]] = tempVar[k].split("=")[1];
	}
	return params;
}


/**
* 图片命名规则
* 时间
* 加随机数，避免重复
* 用户id*/

function imgNameFn(uid) {
	var time = new Date(new Date()).valueOf();
	var _time = returnTime(time, "-", "s").replace(/-| |:/g, ""); //替换-和空格和：
	var random = Math.random() + "";
	var _random = random.substring(2, 7);
	var _endStr = _time + _random + "_u" + uid;
	return _endStr
}



// 去重
function duplicateFn(arr) {
	var newArr = [];
	for (var i = 0; i < arr.length; i++) {
		for (var j = i + 1; j < arr.length; j++) {
			if (arr[i] == arr[j]) {
				++i;
			}
		}
		newArr.push(arr[i]);
	}
	return newArr;
}



 
/**
 * @description: 判断是否有选择的文字
 * @return String
 */
 function getSelectedFn(){
	if (window.getSelection) {
	  //ie9以上及其他
	  return window.getSelection().toString()
	} else {
	  //ie9以下
	  const selection = document.selection;
	  if (selection.text) {
		return selection.text.toString()
	  }
	  return ''
	}
  }



module.exports = {
	returnTime,
	isJSON,
	returnPhone,
	delTips,
	checkIdCard,
	uploadSectionFile,
	countDay,
	deepClone,
	debounceFn,
	tipsFn,
	throttle,
	remRepeat,
	getUrlParams,
	duplicateFn,
	imgNameFn,
	getSelectedFn 
}


// WEBPACK FOOTER //
// ./src/util/utils.js